import React, { Dispatch, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Layouts } from 'app-components';
import NavBarContainer from '../../../containers/common/NavBarContainer';

const AdminSerffStatusContainer = () => {
    return (
        <Layouts id="add-member">
            <Layouts.Row hasGap={true}>
                <div className="grid-col-12">
                    <div className="grid-row">
                        <NavBarContainer navBarClass="ticket-mgmt-top-nav grid-col-12" />
                    </div>
                </div>
                <div className="desktop:grid-col-12" id="main-content">
                    <Outlet />
                </div>
            </Layouts.Row>
        </Layouts>
    );
};

export default AdminSerffStatusContainer;
